import type { QuestDefinition } from '@/types/quests';

export const TUTORIAL_01: QuestDefinition = {
  id: 'tutorial_01',
  name: 'A Word With Old Pete',
  npc: 'old_pete',
  port: 'cutlass_cove',
  rewards: { doubloons: 20, xp: 50 },
  unlocks: ['tutorial_02'],
  initialStage: '0',
  completionStage: '3_done',

  stages: {
    '0': {
      type: 'dialogue',
      npc: 'old_pete',
      text: "Sit down, greenhorn. The salt's still drying on your boots. You came here looking for something — work, gold, a name to make. Doesn't matter to me. What matters is whether you've got the steel for the trade.",
      choices: [
        { label: 'I came here to make my fortune.', nextStage: '1' },
        { label: "I'm looking for work, that's all.", nextStage: '1' },
        { label: "I'll do whatever it takes.", nextStage: '1' },
      ],
    },

    '1': {
      type: 'dialogue',
      npc: 'old_pete',
      text: "Fortune. Work. Whatever it takes. They all say that. Few mean it. Let's see if you do.\n\nThere's a drunk passed out behind the tavern. Has a purse with maybe twenty doubloons in it. He won't notice if it's gone — and if he does, he won't remember who took it. Easy money. The question is whether you can be quiet enough to take it.",
      choices: [
        { label: "I'll do it.", nextStage: '2' },
        { label: "That's stealing from a drunk man.", nextStage: '1a' },
        { label: 'Sounds easy enough.', nextStage: '2' },
      ],
    },

    '1a': {
      type: 'dialogue',
      npc: 'old_pete',
      text: "Aye, it is. And the drunk man drank up his own purse plenty of times before. Welcome to Cutlass Cove, greenhorn. Around here, easy money finds its way to the quickest hands. Yours, or someone else's. Your call.",
      choices: [
        { label: "Fine. I'll do it.", nextStage: '2' },
        { label: 'Find someone else.', nextStage: '1b' },
      ],
    },

    '1b': {
      type: 'dialogue',
      npc: 'old_pete',
      text: "Suit yourself. Come find me when you've got an appetite for the trade. The cove'll still be here. The drunks'll keep drinking.",
      continueText: 'Leave',
      nextStage: 'refused',
    },

    '2': {
      type: 'action',
      description:
        'You slip behind the tavern. The drunk lies face-down in the dirt, his purse half-tucked under him. The cove is quiet. You can hear him breathing. Now or never.',
      buttonText: 'Attempt the Lift',
      successText:
        "Twenty doubloons. The drunk doesn't even stir. You pocket the purse and walk away.",
      rewards: { doubloons: 20 },
      nextStage: '3',
      durationMs: 2000,
    },

    '3': {
      type: 'dialogue',
      npc: 'old_pete',
      text: "Lighter than I thought you'd be. Maybe there's hope for you after all. Keep that purse — you earned it. But you'll need more than twenty doubloons to make a name in Cutlass Cove.\n\nFind Mistress Vela at the Sea Dog Tavern. Tell her Old Pete sent you. She's got work for hands willing to do it. And greenhorn? Try not to get yourself killed before you make me look stupid for trusting you.",
      choices: [{ label: "I'll find her.", nextStage: '3_done' }],
    },

    '3_done': {
      type: 'dialogue',
      npc: 'old_pete',
      text: '',
    },
  },
};
